module.exports = __webpack_public_path__ + "img/ETCVehicleManagement.f8e7a728.svg";